<template>
  <page-loader>
    <v-container>
      <v-row>
        <v-col class="d-flex">
          <v-breadcrumbs :items="breadcrumbs" class="px-0 py-0" />
        </v-col>
      </v-row>
      <v-row class="mt-0">
        <v-col>
          <v-divider />
        </v-col>
      </v-row>
    </v-container>
    <v-container>
      <v-row>
        <v-col>
          <team-select title="Select a team" :options="options" />
        </v-col>
      </v-row>
    </v-container>
  </page-loader>
</template>
<script>
import PageLoader from '@/components/page-loader'
import TeamSelect from '@/components/team-select'
import { mapMutations } from 'vuex'

export default {
  name: 'OrderingIndex',
  components: { PageLoader, TeamSelect },
  data: () => ({
    options: [
      {
        text: 'Organic',
        icon: 'park',
        to: 'navigations.ordering.organic',
      },
      {
        text: 'Performance',
        icon: 'paid',
        to: 'navigations.ordering.performance',
        color: 'blue',
        attributes: {
          dark: true,
        },
      },
    ],
  }),
  computed: {
    breadcrumbs() {
      return [
        { text: 'Offers', to: { name: 'offers.management' }, exact: true },
        { text: 'Ordering', disabled: true },
      ]
    },
  },
  created() {
    this.setPageLoading(false)
  },
  methods: {
    ...mapMutations('general', ['setPageLoading']),
  },
}
</script>
